import { render, staticRenderFns } from "./SkeletonBlocoInforDadosGestao.vue?vue&type=template&id=fd841756&scoped=true&lang=pug"
import script from "./SkeletonBlocoInforDadosGestao.vue?vue&type=script&lang=js"
export * from "./SkeletonBlocoInforDadosGestao.vue?vue&type=script&lang=js"
import style0 from "./SkeletonBlocoInforDadosGestao.vue?vue&type=style&index=0&id=fd841756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd841756",
  null
  
)

export default component.exports